"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "user": { "id": null, "career_meeting_at": null, "is_able_to_be_supported": null, "has_job_offer": null, "will_go_next_education": null, "has_gived_up_jh": null, "user_hf_member": { "hf_member_id": null }, "user_appraisal": { "memo": null } } });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "user": { "id": null, "career_meeting_at": null, "is_able_to_be_supported": null, "has_job_offer": null, "will_go_next_education": null, "has_gived_up_jh": null, "user_hf_member": { "hf_member_id": null }, "user_appraisal": { "memo": null } } });
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.patch("/jtj/commands/hf_member__save_user_appraisal", { params });
    }
};
